import React from "react";

import { RowShell } from "../editor/MatchRow";
import { MatchSection } from "../editor/MatchSections";
import { STATS_TEXT } from "./catalogStatsText";
import { SkeletonRow } from "./StoredMatchRow";

const T = STATS_TEXT.timeline;
const TONE = "step";
const SKELETON_ROWS = 3;

/** One step as a row: its number where the glyph sits, the question or action, and the answer or result beneath. */
function StepRow({ step, number }) {
  const Glyph = () => <span className="le-mrow-num">{number}</span>;
  return (
    <RowShell tone={TONE} icon={Glyph} text={step.text || step.result}
      sub={step.text ? <span className={step.result ? "le-mrow-sub-key" : ""}>{step.result || T.noAnswer}</span> : null}
      control={<span className="sr-only">{T.stepLabel(number)}</span>} />
  );
}

/**
 * The timeline of the diagnosis: every stored step in order, with the Review screen's row geometry. `steps` are
 * catalogStats.timelineSteps; `total` is the count before the server's cap; `loading` shows row-shaped placeholders.
 */
export default function DiagnosisTimeline({ steps, total, loading }) {
  if (loading) {
    return (
      <MatchSection label={T.heading}>
        {Array.from({ length: SKELETON_ROWS }, (_, i) => <SkeletonRow key={i} />)}
      </MatchSection>
    );
  }
  const hidden = Math.max(0, (total || 0) - steps.length);
  return (
    <MatchSection label={T.heading} count={total || steps.length}
      after={steps.length ? (hidden ? <p className="le-muted">{T.more(hidden)}</p> : null) : <p className="le-muted">{T.empty}</p>}>
      {steps.map((step, i) => <StepRow key={step.key} step={step} number={hidden + i + 1} />)}
    </MatchSection>
  );
}
